module.exports = __webpack_public_path__ + "img/UNI.fcf8e1ee.png";